// extracted by mini-css-extract-plugin
export var textInput = "_j6-0";